module.exports = __webpack_public_path__ + "static/media/Cardo-Regular.7245295c.woff2";